module.exports = __webpack_public_path__ + "static/media/light-snowy-weather_200_transparent.d56f5ba7.gif";